import { useNavigate } from "react-router-dom";
import Layout from "../Utils/Layout";
import { Col, Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";

const SEOPage = () => {
  const navigate = useNavigate();
  return (
    <Layout>
      <div className="py-4 fs-3 ps-3" data-aos="fade-left">
        <button
          onClick={() => navigate(-1)}
          className="btn btn-info fw-bold ms-5"
        >
          Back
        </button>
      </div>
      <div>
        <Helmet>
          <title>SEO Services | Shoyeb</title>
          <meta
            name="description"
            content="Boost your website's visibility with our expert SEO services. Contact us for a free consultation!"
          />
          <meta
            name="keywords"
            content="SEO services, search engine optimization, SEO agency"
          />
        </Helmet>
        <Container>
          <Row className="mt-5">
            <Col data-aos="fade-right">
              <h1 className="text-center">SEO Services</h1>
              <p className="lead text-center">
                Improve your online presence and drive organic traffic with our
                professional SEO services.
              </p>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col md={6} data-aos="fade-up">
              <h3>What We Offer</h3>
              <ul>
                <li>Keyword research and analysis</li>
                <li>On-page and off-page optimization</li>
                <li>Content creation and optimization</li>
                <li>Link building strategies</li>
                <li>SEO audits and website analysis</li>
              </ul>
            </Col>
            <Col md={6} data-aos="fade-down">
              <h3>Why Choose Us?</h3>
              <p>
                Our team of experienced SEO specialists is dedicated to helping
                your business succeed online. We utilize proven strategies and
                cutting-edge techniques to deliver measurable results.
              </p>
              <p>
                Whether you&apos;re a small business or a large corporation, we
                can tailor our SEO services to meet your specific needs and
                goals.
              </p>
            </Col>
          </Row>

          <Row className="mt-5">
            <Col data-aos="fade-left">
              <h3>Contact Us</h3>
              <p>
                Ready to boost your website&apos;s visibility and drive more
                organic traffic?
              </p>
              <a href="mailto:shoyebmd424@mail.com" className="btn btn-info">
                Contact Us
              </a>{" "}
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

export default SEOPage;
